import { useFormik } from 'formik';
import { initialValues } from './formData'; // Importa los valores iniciales
import { validationSchema } from './formData';
import { MultiDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface IdentityAndRoleForm {
    [key: string]: MultiDynamicField[];
}

export const useIdentityAndRole = (chatAssistant: ChatAssistant) => {
    const formikIdentityAndRole = useFormik<IdentityAndRoleForm>({
        initialValues,
        validationSchema,
        onSubmit: console.log,
    });

    useEffect(() => {
        if (chatAssistant) {
            formikIdentityAndRole.setValues({
                identityAndRole:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.identityAndRole ?? initialValues.identityAndRole,
            });
        }
    }, [chatAssistant]);

    return { formikIdentityAndRole };
};
